<template>
    <a
        :href="`/projects/${project.slug}`"
        class="project block rounded-lg bg-white hover:bg-gray-100 px-6 pt-4 pb-6 shadow-lg hover:shadow-xl border-transparent border-t-8 hover:border-teal-500 transition duration-200"
    >
        <h2 class="text-2xl font-bold text-teal-600">
            {{ project.title }}
        </h2>
        <div class="flex flex-col md:flex-row mb-2 mt-3">
            <span v-if="project.job_type === 1" class="flex items-center mr-8">
                <svg-icon icon="currency-dollar" class="w-5 mr-1"></svg-icon>
                <span v-if="project.budget > 0" class="text-gray-600 font-bold">{{ project.budget | formattedCurrency }}</span>
                <span v-else class="text-gray-600 font-bold">Negotiable</span>
            </span>
            <span class="flex items-center mr-8">
                <svg-icon icon="calendar" class="w-5 mr-1"></svg-icon>
                <span class="text-gray-600">
                    Posted on <span class="font-semibold">{{ project.published_at_formatted }}</span>
                </span>
            </span>
            <span v-if="project.job_type !== 3" class="flex items-center mr-8">
                <svg-icon icon="wallet" class="w-5 mr-1"></svg-icon>
                <span class="text-gray-600">{{ project.bid_count }} Applicants</span>
            </span>
            <span v-if="project.country" class="flex items-center mr-8">
                <svg-icon icon="location-pin" class="w-5 mr-1"></svg-icon>
                <span class="text-gray-600">{{ project.country }}</span>
            </span>
        </div>
        <!-- <p class="text-gray-800 mb-2">{{ project.description }}</p> -->
        <tags-list :tags="toBeShownTags" :plus-more="numOfNotShownTags"></tags-list>
    </a>
</template>

<script>
export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            toBeShownTags: [],
            numOfNotShownTags: 0
        };
    },

    mounted() {
        this.calculateToBeShownTags();
    },

    methods: {
        calculateToBeShownTags() {
            let allTagsTotalStringLength = 0;
            let allTags = this.project.tags_translated;

            this.toBeShownTags = allTags
                .filter(tag => {
                    if (tag.length + allTagsTotalStringLength >= 50) {
                        return false;
                    }

                    allTagsTotalStringLength += tag.length;
                    return true;
                })
                .slice(0, 6);

            this.numOfNotShownTags = allTags.length - this.toBeShownTags.length;
        }
    }
};
</script>
